import { getActionTypes } from './get-actions';

import { getInitialState } from '.';

export const getReducer = (actionPrefix) => (action) => ({
  [getActionTypes(actionPrefix).SET_CONFIRM_BOTTOM_DIALOG]: () => ({
    confirmBottomDialog: action.payload.confirmBottomDialog.isShown
      ? action.payload.confirmBottomDialog
      : {
          ...action.payload.confirmBottomDialog,
          ctaPrimaryLabel: getInitialState().confirmBottomDialog.ctaPrimaryLabel,
          message: getInitialState().confirmBottomDialog.message,
        },
  }),
  [getActionTypes(actionPrefix).SET_ACTIVE_BLOCK]: () => ({
    activeBlock: action.payload.blockType,
  }),
  [getActionTypes(actionPrefix).SET_NOTIFICATION_STATUS]: () => ({
    notificationStatus: action.payload.notificationStatus.isShown
      ? action.payload.notificationStatus
      : { ...action.payload.notificationStatus, message: getInitialState().notificationStatus.message },
  }),
  [getActionTypes(actionPrefix).SELECT_TAB]: () => ({
    selectedTab: action.payload.selectedTab,
  }),
  [getActionTypes(actionPrefix).SET_MODAL_TOOLTIP]: (state) => ({
    modalTooltip: { ...state.modalTooltip, ...action.payload.modalTooltip },
  }),
  [getActionTypes(actionPrefix).SET_PREMIUM_STATUS]: (state) => ({
    premiumStatus: { ...state.premiumStatus, ...action.payload.premiumStatus },
  }),
});
